const state = {
  showModal: false
}

const mutations = {
  setModal: function (state, payload) {
    state.showModal = payload
  }
}

const actions = {
  setModal: function (context, value) {
    context.commit('setModal', value)
  }
}

const getters = {
  showModal: state => {
    return state.showModal
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js